function validateForm(form, options) {
    var el = this;
    el.options = options;
    el.form = form;
    el.inputs = [];
    el.url = '';
    el.submitButton = null;
    el.sending = false;
    el.settings = {
        successMsg: 'Form inviato correttamente',
        sendingMsg: "Invio in corso...",
        question: {
            text: "Sei sicuro?",
            icon: "error",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Continua!",
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: "button button-secondary",
                cancelButton: "button button-default"
            }
        },
        onSubmit: function () {
            Swal.fire({
                text: this.sendingMsg,
                showConfirmButton: false,
            });
            el.formData = el.getData(el.formData);
            el.submitForm();
        },
        onServerError: function (data) {
            console.log(data);
            Swal.fire({
                icon: 'error',
                text: "Si è verificato un errore",
                buttonsStyling: false,
                confirmButtonText: "Chiudi",
                customClass: {
                    confirmButton: "button button-default"
                }
            });
        },
        onFormError: function (data) {
            console.log(data);
            if (data.length > 0) {
                Swal.fire({
                    icon: 'error',
                    html: "<p>" + data.join('<br>') + "</p>",
                    buttonsStyling: false,
                    confirmButtonText: "Chiudi",
                    customClass: {
                        confirmButton: "button button-default"
                    }
                });
            }
        },
        onSuccess: function (data) {
            console.log(data);
            Swal.fire({
                icon: 'success',
                html: this.successMsg,
                buttonsStyling: false,
                confirmButtonText: "Chiudi",
                customClass: {
                    confirmButton: "button button-primary"
                }
            }).then((result) => {
                el.settings.onSuccessAlertClose(data);
            });
        },
        onSuccessAlertClose: function (data) {
            console.log(data);
        }
    };
    el.data = {
        parent: 'data-form-parent',
        error: 'data-form-error',
        submit: 'data-form-submit',
        question: 'data-form-question',
        hint: 'data-form-hint'
    };
    el.sels = {
        parent: '[' + el.data.parent + ']',
        error: '[' + el.data.error + ']',
        submit: '[' + el.data.submit + ']',
        question: '[' + el.data.question + ']',
        hint: '[' + el.data.hint + ']',
    };
    el.formData = new FormData();

    el.init = function () {
        var q = $.extend(el.settings.question, el.options.question);
        $.extend(el.settings, el.options);
        el.settings.question = q;
        el.getInputs();
        el.url = $(el.form).attr('action');
        el.submitButton = $(el.form).find(el.sels.submit);
        el.questionButton = $(el.form).find(el.sels.question);
        $(el.inputs).each(function () {
            var element = this;
            $(this.input).on('blur', function () {
                el.validateInput(element);
            });
            $(this.input).on('change', function () {
                el.validateInput(element);
            });
        });
        $(el.submitButton).on('click', function () {
            if (el.validate()) {
                el.settings.onSubmit();
            }
        });
        $(el.form).on('keypress', function(e) {
            if(e.which == 13){
                e.preventDefault();
                if (el.validate()) {
                    el.settings.onSubmit();
                }
            }
        });
        $(el.questionButton).on('click', function () {
            el.question();
        });
    };

    el.getInputs = function () {
        $(el.form).find(el.sels.parent).each(function () {
            var input = $(this).find('input').length ? $(this).find('input') : ($(this).find('select').length ? $(this).find('select') : $(this).find('textarea'));
            var par = this;
            $(input).each(function () {
                if ($(this).attr('type') != 'hidden') {
                    $(this).on('blur', function () {
                        el.validateInput(obj);
                    });
                    var obj = {
                        input: this,
                        parent: par,
                        error: $(par).find(el.sels.error),
                        name: $(this).attr('name')
                    };
                    if ($(this).attr('data-input-date-min') !== undefined) {
                        var min = parseInt($(this).attr('data-input-date-min'));
                        var max = parseInt($(this).attr('data-input-date-max'));
                        var span = parseInt($(this).attr('data-input-date-span'));
                        var value = parseInt($(this).attr('data-input-value'));
                        var valuemin = parseInt($(this).attr('data-input-valuemin'));
                        var valuemax = parseInt($(this).attr('data-input-valuemax'));
                        var opt = {
                            singleDatePicker: true,
                            showDropdowns: true,
                            locale: {
                                format: "DD/MM/YYYY",
                                separator: " - ",
                                applyLabel: "Applica",
                                cancelLabel: "Annulla",
                                fromLabel: "Da",
                                toLabel: "A",
                                customRangeLabel: "Personalizzato",
                                cancelLabel: 'Rimuovi',
                                weekLabel: "W",
                                daysOfWeek: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
                                monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
                                firstDay: 1
                            },
                        }
                        if (value > 0) {
                            opt.startDate = moment(value * 1000);
                        }
                        if (valuemin > 0 && valuemax) {
                            opt.startDate = moment(valuemin * 1000);
                            opt.endDate = moment(valuemax * 1000);
                        }
                        if ($(this).attr('data-input-date-span') != undefined) {
                            opt.singleDatePicker = false;
                        }
                        if ($(this).attr('data-input-time') != undefined) {
                            opt.timePicker = true;
                            opt.timePicker24Hour = true;
                            opt.locale.format = "DD/MM/YYYY HH:mm";
                        }
                        if (span > 0) {
                            opt.maxSpan = { days: span };
                        }
                        if (min > 0) {
                            opt.minDate = moment(min * 1000);
                        }
                        if (max > 0) {
                            opt.maxDate = moment(max * 1000);
                        }
                        // 13/10/2026 - Campi con data-form-date-error: il calendario non scrive da solo la data nel campo all'apertura/chiusura; il valore viene impostato solo con un click sul giorno (autoApply)
                        if ($(this).attr('data-form-date-error') != undefined) {
                            opt.autoUpdateInput = false;
                            opt.autoApply = true;
                        }
                        $(this).daterangepicker(opt);
                        if (opt.autoUpdateInput === false) {
                            $(this).on('apply.daterangepicker', function(ev, picker) {
                                $(this).val(picker.startDate.format(picker.locale.format)).trigger('change');
                            });
                        }
                        $(this).on('cancel.daterangepicker', function(ev, picker) {
                            //do something, like clearing an input
                            $(this).val('');
                        });
                        $(this).val("");
                    }
                    el.inputs[el.inputs.length] = obj;
                }
            });
        });
    };

    el.validateInput = function (element) {
        var value = $(element.input).val();
        var msg = el.validateValue(element.input, value);
        var valid = msg === true;
        el.setInputError(element, valid, msg);
        return valid;
    };

    // 13/10/2026 - Controllo data scritta a mano: valida solo i campi con data-form-date-error (la data minima e' quella di data-input-date-min)
    el.validateDateMin = function (input, value) {
        var date = moment(value, ['DD/MM/YYYY', 'D/M/YYYY'], true);
        var min = moment(parseInt($(input).attr('data-input-date-min')) * 1000);
        return date.isValid() && !date.isBefore(min, 'day');
    };

    el.validateValue = function (input, value) {
        var required = $(input).attr('required') !== undefined;
        var maxlength = parseInt($(input).attr('data-form-maxlength'));
        var min = parseInt($(input).attr('data-form-min'));
        var max = parseInt($(input).attr('data-form-max'));
        var msg = true;
        if (value == undefined || value == null || value == '') {
            if (required) {
                msg = formErrors.required;
            }
        }
        else {
            if (($(input).attr('type') == 'number' || $(input).attr('data-form-type') == 'number') && isNaN(value)) {
                msg = formErrors.number;
            }
            else if ($(input).attr('type') == 'url' && !/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(value)) {
                msg = formErrors.url;
            }
            else if ($(input).attr('type') == 'email' && !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value)) {
                msg = formErrors.email;
            }
            else if ($(input).attr('data-newpassword') != undefined && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/g.test(value)) {
                msg = formErrors.newpassword;
            }
            else if($(input).attr('data-equals') != undefined && $($(input).attr('data-equals')).val() != value){
                msg = formErrors.equals;
            }
            else if(maxlength > 0 && value.length > maxlength){
                msg = formErrors.maxlength.replace("{num}", maxlength);
            }
            else if(min > 0 && Number(value) < min){
                msg = formErrors.min.replace("{num}", min);
            }
            else if(max > 0 && Number(value) > max){
                msg = formErrors.max.replace("{num}", max);
            }
            else if($(input).attr('data-form-date-error') != undefined && $(input).attr('data-input-date-min') != undefined && !el.validateDateMin(input, value)){
                msg = $(input).attr('data-form-date-error') + ' ' + moment(parseInt($(input).attr('data-input-date-min')) * 1000).format('DD/MM/YYYY') + '.';
            }
        }
        return msg;
    };

    el.setInputError = function (element, valid, msg, server) {
        if (valid) {
            if (server || !$(element.parent).hasClass('server-error')) {
                $(element.parent).removeClass('invalid');
                $(element.error).text('');
            }
        }
        else {
            $(element.parent).addClass('invalid');
            $(element.error).text(msg);
            if (server) {
                $(element.parent).addClass('server-error');
            }
        }
    };

    el.validate = function () {
        var valid = true;
        $(el.inputs).each(function () {
            var v = el.validateInput(this);
            valid = valid ? v : valid;
        });
        console.log(valid);
        return valid;
    };

    el.getData = function (formData) {
        formData = new FormData($(el.form).get(0));
        return formData;
    };

    el.validateServer = function (data) {
        var formerrors = [];
        $(data.errors).each(function () {
            if (this.type == 1) {
                var error = this;
                $(el.inputs).each(function () {
                    if (this.name == error.name) {
                        el.setInputError(this, false, error.msg, true);
                    }
                });
            }
            else {
                formerrors[formerrors.length] = '<li>' + this.msg + '</li>';
            }
        });
        return formerrors;
    };

    el.submitForm = function () {
        if (!el.sending) {
            el.sending = true;
            $.ajax({
                type: 'POST',
                url: el.url,
                data: el.formData,
                dataType: 'json',
                cache: false,
                contentType: false,
                processData: false,
                success: function (data) {
                    Swal.close();
                    if (data.id) {
                        el.settings.onSuccess(data);
                    }
                    else {
                        var errors = el.validateServer(data);
                        el.settings.onFormError(errors);
                    }
                    el.sending = false;
                },
                error: function (err) {
                    el.sending = false;
                    el.settings.onServerError(err);
                }
            });
        }
    };

    el.question = function () {
        Swal.fire(el.settings.question).then((result) => {
            if (result.isConfirmed) {
                el.settings.onSubmit();
            }
        });
    }

    el.setOptions = function(options){
        el.options = options;
    }

    return el;
}